// No imports on purpose: api.js uses these, and utils.js imports api.js transitively.

export function setCookie(name, value, maxAgeSeconds) {
  const maxAge = maxAgeSeconds ? `; Max-Age=${maxAgeSeconds}` : '';
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';

  document.cookie = `${name}=${value || ''}${maxAge}; path=/; SameSite=Strict${secure}`;
}

export function deleteCookie(name) {
  document.cookie = `${name}=; Max-Age=0; path=/`;
}

export function getCookie(name) {
  const cookies = document.cookie.split(';').map(cookie => cookie.trim());

  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }

  return undefined;
}
